import { Category, Video, Episode } from "./types";

var cachedVideos;
var cachedEpisodes;

export var whenAvailable = function (name, callback) {
    var interval = 10; // ms
    window.setTimeout(function() {
        if (window[name]) {
            callback(window[name]);
        } else {
            whenAvailable(name, callback);
        }
    }, interval);
}


export var getVideos = function(): Promise<Category[]>{
    return new Promise(function (resolve, reject) {
        if(cachedVideos) {
            resolve(cachedVideos);
            return;
        }
        $.ajax({
            url: "/data/videos.json",
            type: "get",
            dataType: 'json',
            processData: true,
        }).then(function (data) {
            resolve(data);
        }, reject);
    });
}

export var getVideoBySEO = function(seoName: String): Promise<Video>{
    return new Promise(async function (resolve, reject) {
        var videos = await getVideos();
        videos.forEach(function(category){
            category.Videos.forEach(function(video){
                if(video.SeoName == seoName) {
                    resolve(video);
                    return;
                }
            })
        })
    });
}

export var getUpNext = function(id: String): Promise<Video>{
    return new Promise(async function (resolve, reject) {
        var videos = await getVideos();
        var resolveNext = false;
        videos.forEach(function(category){
            category.Videos.forEach(function(video){
                if(resolveNext) {
                    resolve(video);
                    resolveNext = false;
                    return;
                }
                if(video.Id == id) {
                    resolveNext = true;
                }
            })
        });
        if(resolveNext) {
            resolve(videos[0].Videos[0]);
        }
    });
}


export var draftCall = function (method, params) {
    return new Promise(function (resolve, reject) {
        params = params || {};
        params.method = method;
        params.locale = params.locale || $('html').attr('lang');
        var options = {
            url: tvUrl + "/info/",
            type: "get",
            dataType: 'json',
            processData: true,
            data: params,
        };

        $.ajax(options).then(function (data) {
            if (data && data.error && data.error.data) {
                var errorCode = data.error.data;
                console.error(data.error);
                reject(data);
            } else {
                var result = data.result || data;
                resolve(result);
            }
        }, reject);
    });
};


export var getEpisodesForCampaign = function (id, width): Promise<Episode[]> {
    return new Promise(function (resolve, reject) {
        if(cachedEpisodes) {
            resolve(cachedEpisodes);
            return;
        }
        draftCall('episodes.list', {
            id: "voices-for-humanity",
            campaign: id,
            skip_breaks: true,
            html_response: true,
            width: Math.round(width * window.devicePixelRatio),
        }).then(function (result: Episode[]) {
            cachedEpisodes = result;
            resolve(result);
        });
    });
};

export var getFeaturedEpisode = function(id, width): Promise<Episode>{
    return new Promise(async function (resolve, reject) {
        var episodes = await getEpisodesForCampaign(id, width);
        var featuredEpisode = episodes[0];
        resolve(featuredEpisode);
    });
}

// // write a function to get html of the url
// // and extract html from element with id="video"
// // and return that html
// var getFullDescriptionHTML = function(episode: Episode): Promise<string>{

//     return new Promise(function (resolve, reject) {
//         $.ajax({
//             url: episode.Link,
//             type: "GET",
//             dataType: 'html',
//             xhrFields: {
//                 withCredentials: false
//            },
//             // processData: true,
//         }).then(function (data) {
//             var html = $(data).find('.editable-body').html();
//             $(html).find('h1').remove();
//             resolve(html);
//         }, reject);
//     });
// }



export var getEpisodeBySEO = function(id, width, seoName: String): Promise<Video>{
    return new Promise(async function (resolve, reject) {
        var epsiodes = await getEpisodesForCampaign(id, width);
        var fullPath = "/series/voices-for-humanity/" + seoName;
        epsiodes.forEach(function(episode: Episode){
            if(episode.Path == fullPath) {
                resolve(episode);
                return;
            }
        });
    });
}

export var getNextEpisodeNext = function(id, episodeid: String, width: number): Promise<Video>{
    return new Promise(async function (resolve, reject) {
        var episodes = await getEpisodesForCampaign(id, width);
        var resolveNext = false;
        episodes.forEach(function(episode){
            if(resolveNext) {
                resolve(episode);
                resolveNext = false;
                return;
            }
            if(episode.Id == episodeid) {
                resolveNext = true;
            }
        });
        if(resolveNext) {
            resolve(episodes[0]);
        }
    });
}

export var stripHTML = function(html: string): string{
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}